module.exports = __webpack_public_path__ + "img/icon-speed-8.68345c53.svg";